module.exports = __webpack_public_path__ + "static/media/bolt-purple.17ac6433.svg";